import styled from '@emotion/styled'
import { withClass } from 'common/emotion'

import { calcRem, breakpoint } from 'component-library/__styling/style-functions'
import { breakWords } from 'component-library/__styling/style-mixins'
import { colors, metrics } from 'component-library/__styling/settings'

import { Sharing } from 'component-library/buttons/Sharing/Sharing'
import { CardInteractionHoverStylesPerthNow } from 'component-library/cards/CardText/CardTextInteractions.styled'

const styledLandscapeWideClassName = 'LandscapeWideCard'
export const styledHeadlineClassName = 'Card-Headline'

export const StyledLandscapeWide = withClass(styledLandscapeWideClassName)(
    styled('div')({
        ...breakWords,
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        overflow: 'hidden',
        padding: calcRem(metrics.perthnow.margins.md, metrics.perthnow.margins.sm),
        ...CardInteractionHoverStylesPerthNow,
        background: colors.white,
    })
)

export const StyledSharing = styled(Sharing)({
    display: 'none',

    [breakpoint('xs')]: {
        display: 'block',
        flex: `0 0 ${calcRem(110)}`,
        alignSelf: 'center',
        paddingLeft: calcRem(metrics.perthnow.margins.sm),
        borderLeft: `1px solid ${colors.perthnow.greyMarble}`,
        marginLeft: calcRem(metrics.perthnow.margins.sm),
        marginRight: calcRem(metrics.perthnow.margins.sm),
    },
})
StyledSharing.displayName = 'StyledSharing'
